import React from "react";
import { ButtonProps } from "../../service/interfaces/Components";
import SecureImage from "../BucketImage/Image";

const CustomButton: React.FC<ButtonProps> = ({
  label,
  onClick,
  icon,
  buttonClassName = "",
  labelClassName = "",
  type = "button"
}) => {
  return (
    <div className="flex items-center space-x-2">
      <button
        className={`bg-[#444FBD] flex items-center justify-center rounded-[5px] gap-1 px-2 py-1 ${buttonClassName}`}
        onClick={onClick}
        type={type}
      >{
          icon && <SecureImage fileKey={icon} alt="header icon" width="12px" />
        }
        {label && (
          <span className={`text-[14px] text-white ${labelClassName}`}>
            {label}
          </span>
        )}
      </button>
    </div>
  );
};

export default CustomButton;
